import { combineReducers } from "redux";

import user from "./User";
import config from "./Config";
import communities from "./Communities";

export default combineReducers({ user, config, communities });



// WEBPACK FOOTER //
// ./src/components/reducers/index.js